<template>
  <v-autocomplete
    v-model="localValue"
    :chips="chips"
    :clearable="clearable"
    :counter="showCounter"
    :deletable-chips="deletableChips"
    :dense="dense"
    :disabled="disabled"
    :item-text="selectedItemToText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :loading="loading"
    :messages="messages"
    :multiple="false"
    :no-filter="noFilter"
    :outlined="outlined"
    :placeholder="showPlaceholder"
    :prepend-inner-icon="prependInnerIcon"
    :return-object="false"
    :rounded="rounded"
    :search-input.sync="search"
    :shaped="shaped"
    :single-line="singleLine"
    :small-chips="smallChips"
    :rules="rules"
    @change="$emit('change', $event)"
    @click:clear="loadItems()"
  >
    <template v-slot:prepend-item>
      <v-row class="d-flex v-list-item">
        <slot name="prepend-item"></slot>
      </v-row>
    </template>
    <template v-slot:item="data">
      <v-row class="d-flex" style="width: 100%">
        <slot :data="data" name="item"></slot>
      </v-row>
    </template>
  </v-autocomplete>
</template>

<script>
import SingleAutocomplete from './SingleAutocomplete';

export default {
  mixins: [SingleAutocomplete],
  props: {
    value: {
      type: Number,
      default: null
    }
  }
};
</script>

<style scoped></style>
